import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "dateInput"]

  connect() {
    // Bind click outside to close modal
    this.boundHideForm = this.hideForm.bind(this)
  }

  showForm(event) {
    event.preventDefault()
    const date = event.currentTarget.dataset.date

    if (this.hasDateInputTarget) {
      this.dateInputTarget.value = date
    }

    if (this.hasModalTarget) {
      this.modalTarget.classList.add("modal-open")
    }
  }

  hideForm(event) {
    if (event) {
      event.preventDefault()
    }

    if (this.hasModalTarget) {
      this.modalTarget.classList.remove("modal-open")
    }

    // Reset form
    const form = document.getElementById("holiday_form")
    if (form) {
      form.reset()
    }
  }

  submitForm(event) {
    // 폼 제출 후 모달만 닫기 (리셋하지 않음 - 리셋은 turbo 응답 후에)
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove("modal-open")
    }
  }
}
